import {
  ColumnDataType,
  GetOutputSchemaParams,
  Provider,
  TableSchema,
  WorkflowComponentCodeParams,
  WorkflowComponentParamType
} from '../types'
import { SelectWorkflowComponent } from './common/selectcomponent'

class GeneratePoints extends SelectWorkflowComponent {
  constructor() {
    super(
      {
        name: 'native.generatepoints',
        group: 'Spatial Constructors',
        title: 'ST Generate Points',
        description: `
        This component generates a table with a specified number of random points contained within each polygon in the input table.
      `,
        starred: true
      },
      [
        {
          name: 'source',
          type: WorkflowComponentParamType.InputTable,
          title: 'Source table'
        },
        {
          name: 'geo',
          type: WorkflowComponentParamType.Column,
          title: 'Geo column',
          parent: 'source',

          dataType: [ColumnDataType.Geography, ColumnDataType.Geometry]
        },
        {
          name: 'npoints',
          type: WorkflowComponentParamType.Number,
          title: 'Number of points',
          default: 100,
          min: 1,
          optional: true
        }
      ]
    )
  }

  getInnerSql({ params, connection, envVars }: WorkflowComponentCodeParams) {
    if (connection.type !== Provider.BigQuery) {
      return null
    }
    return `WITH points AS (
              SELECT ${connection.quoteName(
                envVars.analyticsToolboxDataset as string
              )}.ST_GENERATEPOINTS(${params.geo}, ${params.npoints}) pts
              FROM ${connection.quoteName(params.source as string)}
            )
            SELECT geom
            FROM points, UNNEST(pts) geom`
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  getVersion(provider: Provider): string {
    return '2'
  }

  canProvideOutputSchemas(): boolean {
    return true
  }

  getOutputSchema({ connection }: GetOutputSchemaParams): TableSchema {
    return [
      {
        name: 'geom',
        type: connection.getGeoDataType()
      }
    ]
  }
  supportedProviders(): Provider[] {
    return [Provider.BigQuery]
  }
}

export { GeneratePoints }
